import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CheckCircle2, ArrowRight, Zap, Image as ImageIcon, Check } from 'lucide-react';
import { Footer } from '../components/Footer';
export function CheckoutLloydPage() {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const mainPrice = 27;
  const bump1Price = 47;
  const bump2Price = 17;
  const total = mainPrice + (bump1 ? bump1Price : 0) + (bump2 ? bump2Price : 0);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const fadeIn = {
    initial: {
      opacity: 0,
      y: 20
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.5
    }
  };
  const handlePurchase = () => {
    // Redirect to Shopify checkout — replace with real permalink
    window.location.href = 'https://shopify.com';
  };
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-[#06b6d4] selection:text-black" data-id="element-1250">
      {/* Header */}
      <header className="border-b border-gray-800 bg-black/50 backdrop-blur-md sticky top-0 z-50" data-id="element-1251">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between" data-id="element-1252">
          <div className="flex items-center gap-2" data-id="element-1253">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#06b6d4] to-[#0891b2] flex items-center justify-center shadow-[0_0_15px_rgba(6,182,212,0.5)]" data-id="element-1254">
              <Zap className="w-5 h-5 text-white" data-id="element-1255" />
            </div>
            <span className="font-black text-xl tracking-tight" data-id="element-1256">HeyLloyd</span>
          </div>
          <div className="flex items-center gap-2 text-emerald-400 text-sm font-medium bg-emerald-400/10 px-3 py-1.5 rounded-full border border-emerald-400/20" data-id="element-1257">
            <Lock className="w-4 h-4" data-id="element-1258" />
            <span data-id="element-1259">Pago 100% Seguro</span>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-8 md:py-12 space-y-8" data-id="element-1260">
        {/* Page Title */}
        <motion.div {...fadeIn} className="text-center" data-id="element-1261">
          <h1 className="text-2xl md:text-3xl font-black mb-2" data-id="element-1262">Tu Orden</h1>
          <p className="text-gray-400" data-id="element-1263">
            Selecciona tus complementos y completa tu compra.
          </p>
        </motion.div>

        {/* Main Product */}
        <motion.div {...fadeIn} transition={{
        delay: 0.1
      }} className="bg-gray-900/50 border border-gray-800 rounded-2xl p-6" data-id="element-1264">
          <div className="flex items-center gap-4" data-id="element-1265">
            <div className="w-14 h-14 bg-gradient-to-br from-[#06b6d4]/20 to-[#0891b2]/20 rounded-xl flex items-center justify-center border border-[#06b6d4]/30 shrink-0" data-id="element-1266">
              <Zap className="w-7 h-7 text-[#06b6d4]" data-id="element-1267" />
            </div>
            <div className="flex-1" data-id="element-1268">
              <h2 className="text-lg md:text-xl font-bold text-white" data-id="element-1269">
                HeyLloyd Assistant
              </h2>
              <p className="text-sm text-gray-400" data-id="element-1270">
                Tu asistente de creación digital con IA — Acceso Inmediato
              </p>
            </div>
            <p className="text-2xl font-black text-white shrink-0" data-id="element-1271">
              ${mainPrice}
            </p>
          </div>
        </motion.div>

        {/* Order Bumps */}
        <motion.div {...fadeIn} transition={{
        delay: 0.2
      }} className="space-y-4" data-id="element-1272">
          <h2 className="text-lg font-bold text-gray-300" data-id="element-1273">
            Mejora tu orden (Opcional)
          </h2>

          {/* Bump 1: AI Web Closer */}
          <div className={`relative rounded-2xl p-5 md:p-6 transition-all duration-300 cursor-pointer border-2 ${bump1 ? 'bg-yellow-500/10 border-yellow-500' : 'bg-gray-900/50 border-dashed border-yellow-500/50 hover:border-yellow-500/80'}`} onClick={() => setBump1(!bump1)} data-id="element-1274">
            {bump1 && <div className="absolute -top-3 -right-3 bg-yellow-500 text-black w-8 h-8 rounded-full flex items-center justify-center shadow-lg" data-id="element-1275">
                <Check className="w-5 h-5 font-bold" data-id="element-1276" />
              </div>}
            <div className="flex items-start gap-4" data-id="element-1277">
              <div className={`mt-1 w-6 h-6 rounded border-2 flex-shrink-0 flex items-center justify-center transition-colors ${bump1 ? 'bg-yellow-500 border-yellow-500' : 'border-gray-500'}`} data-id="element-1278">
                {bump1 && <Check className="w-4 h-4 text-black" data-id="element-1279" />}
              </div>
              <div className="flex-1" data-id="element-1280">
                <div className="flex flex-wrap items-baseline gap-2 mb-1" data-id="element-1281">
                  <h3 className="text-lg font-bold text-yellow-400" data-id="element-1282">
                    Sí, quiero AI Web Closer
                  </h3>
                  <span className="text-white font-black bg-yellow-500/20 px-2 py-0.5 rounded text-sm" data-id="element-1283">
                    +${bump1Price}
                  </span>
                </div>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-1284">
                  <span className="font-bold text-white" data-id="element-1285">
                    Cierra ventas en automático.
                  </span>{' '}
                  Agrega el asistente de IA entrenado específicamente para
                  manejar objeciones y cerrar ventas por ti 24/7. El complemento
                  perfecto para tu producto digital.
                </p>
              </div>
            </div>
          </div>

          {/* Bump 2: Meta Ads Images */}
          <div className={`relative rounded-2xl p-5 md:p-6 transition-all duration-300 cursor-pointer border-2 ${bump2 ? 'bg-[#06b6d4]/10 border-[#06b6d4]' : 'bg-gray-900/50 border-dashed border-[#06b6d4]/50 hover:border-[#06b6d4]/80'}`} onClick={() => setBump2(!bump2)} data-id="element-1286">
            {bump2 && <div className="absolute -top-3 -right-3 bg-[#06b6d4] text-black w-8 h-8 rounded-full flex items-center justify-center shadow-lg" data-id="element-1287">
                <Check className="w-5 h-5 font-bold" data-id="element-1288" />
              </div>}
            <div className="flex items-start gap-4" data-id="element-1289">
              <div className={`mt-1 w-6 h-6 rounded border-2 flex-shrink-0 flex items-center justify-center transition-colors ${bump2 ? 'bg-[#06b6d4] border-[#06b6d4]' : 'border-gray-500'}`} data-id="element-1290">
                {bump2 && <Check className="w-4 h-4 text-black" data-id="element-1291" />}
              </div>
              <div className="flex-1" data-id="element-1292">
                <div className="flex flex-wrap items-baseline gap-2 mb-1" data-id="element-1293">
                  <h3 className="text-lg font-bold text-[#06b6d4]" data-id="element-1294">
                    Sí, quiero Imágenes para Meta Ads
                  </h3>
                  <span className="text-white font-black bg-[#06b6d4]/20 px-2 py-0.5 rounded text-sm" data-id="element-1295">
                    +${bump2Price}
                  </span>
                </div>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-1296">
                  <span className="font-bold text-white" data-id="element-1297">
                    Tráfico inmediato.
                  </span>{' '}
                  Aprende a crear imágenes estáticas de alta conversión para
                  Meta Ads usando IA. Deja de perder dinero en anuncios que
                  nadie clickea.
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Summary + CTA */}
        <motion.div {...fadeIn} transition={{
        delay: 0.3
      }} className="bg-gray-900 border border-gray-800 rounded-2xl overflow-hidden shadow-2xl relative" data-id="element-1298">
          <div className="absolute -inset-4 bg-gradient-to-b from-[#06b6d4]/10 to-transparent blur-xl pointer-events-none" data-id="element-1299"></div>

          <div className="p-6 relative z-10" data-id="element-1300">
            <h3 className="text-xl font-black mb-5" data-id="element-1301">Resumen de Orden</h3>

            <div className="space-y-3 mb-6" data-id="element-1302">
              {/* Main Product */}
              <div className="flex justify-between items-center py-2 border-b border-gray-800" data-id="element-1303">
                <div className="flex items-center gap-3" data-id="element-1304">
                  <Zap className="w-5 h-5 text-[#06b6d4]" data-id="element-1305" />
                  <span className="font-medium" data-id="element-1306">HeyLloyd Assistant</span>
                </div>
                <span className="font-bold" data-id="element-1307">${mainPrice}</span>
              </div>

              {/* Bump 1 */}
              {bump1 && <div className="flex justify-between items-center py-2 border-b border-gray-800" data-id="element-1308">
                  <div className="flex items-center gap-3" data-id="element-1309">
                    <CheckCircle2 className="w-5 h-5 text-yellow-500" data-id="element-1310" />
                    <span className="font-medium" data-id="element-1311">AI Web Closer</span>
                  </div>
                  <span className="font-bold" data-id="element-1312">${bump1Price}</span>
                </div>}

              {/* Bump 2 */}
              {bump2 && <div className="flex justify-between items-center py-2 border-b border-gray-800" data-id="element-1313">
                  <div className="flex items-center gap-3" data-id="element-1314">
                    <ImageIcon className="w-5 h-5 text-[#06b6d4]" data-id="element-1315" />
                    <span className="font-medium" data-id="element-1316">Meta Ads Images</span>
                  </div>
                  <span className="font-bold" data-id="element-1317">${bump2Price}</span>
                </div>}
            </div>

            {/* Total */}
            <div className="flex justify-between items-center mb-6 pt-2" data-id="element-1318">
              <p className="text-lg text-gray-400" data-id="element-1319">Total</p>
              <p className="text-3xl font-black text-white" data-id="element-1320">${total}</p>
            </div>

            {/* CTA Button */}
            <button onClick={handlePurchase} className="w-full bg-gradient-to-b from-[#06b6d4] to-[#0891b2] hover:from-[#0891b2] hover:to-[#0e7490] text-white font-black text-lg rounded-xl py-4 shadow-[0_0_20px_rgba(6,182,212,0.3)] hover:shadow-[0_0_30px_rgba(6,182,212,0.5)] transition-all duration-300 transform hover:scale-[1.02] flex items-center justify-center gap-2 group" data-id="element-1321">
              COMPRAR AHORA
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-1322" />
            </button>

            <p className="text-center text-xs text-gray-500 mt-4" data-id="element-1323">
              Serás redirigido a Shopify para completar tu pago de forma segura.
            </p>
          </div>
        </motion.div>

        {/* Trust Badges */}
        <motion.div {...fadeIn} transition={{
        delay: 0.4
      }} className="grid grid-cols-2 gap-4" data-id="element-1324">
          <div className="bg-gray-900/50 border border-gray-800 rounded-xl p-4 flex items-center gap-3" data-id="element-1325">
            <ShieldCheck className="w-8 h-8 text-emerald-400 shrink-0" data-id="element-1326" />
            <div data-id="element-1327">
              <p className="text-sm font-bold text-white leading-tight" data-id="element-1328">
                Garantía 100%
              </p>
              <p className="text-xs text-gray-500" data-id="element-1329">Libre de riesgo</p>
            </div>
          </div>
          <div className="bg-gray-900/50 border border-gray-800 rounded-xl p-4 flex items-center gap-3" data-id="element-1330">
            <Lock className="w-8 h-8 text-[#06b6d4] shrink-0" data-id="element-1331" />
            <div data-id="element-1332">
              <p className="text-sm font-bold text-white leading-tight" data-id="element-1333">
                Pago Seguro
              </p>
              <p className="text-xs text-gray-500" data-id="element-1334">Cifrado SSL</p>
            </div>
          </div>
        </motion.div>
      </main>

      <Footer data-id="element-1335" />
    </div>;
}